import styled from 'styled-components';
const InviteViaTextWrapper = styled.div`
.w-50{
    width:50%;
}
.invite-form-wrapper{
    >header{
        // padding:40px 50px 10px;
        >h2{
            font-family: "Open Sans";
            font-weight: 500;
            font-size: 14px;
            color: #1f337a;
            line-height: normal;
            margin: 0px;
            padding: 0 0 10px;
        }
        >h1{
            font-family: 'Open Sans',sans-serif;
            font-size:24px;
            font-weight: bold;
            color: #333e61;
            text-transform: capitalize;
            display: inline-block;
            margin: 0;
            padding: 0 0 5px 20px;
        }
        >h3{
            line-height: normal;
            font-size: 12px;
            font-weight: 700;
            color: #08b2e3;
            text-transform: uppercase;
            display: block;
            margin: 0;
            padding: 0;
        }
        
    }

    .textLabel{
        margin-bottom:10px;
        label{
            font-family: 'Open Sans',sans-serif;
            font-size: 16px;
            font-weight: 500;
            color: #344177;
            text-transform: capitalize;
            display: block;
            margin: 0;
            padding: 0;
            line-height: normal;
        }
    }
    .textBoxPhone{
        font-family: 'Open Sans',sans-serif;
        font-weight:500;
        border:none;
        border-radius:0;
        border-bottom:1px solid rgba(0,0,0,0.1);
        padding-left: 0;
        color:#32407b;
        font-size:17px;
        &:focus{
            outline:none;
            box-shadow:none;
        }
    }

.invite-form-content{
    padding:20px 20px;
    .list-item{
        margin:0 0 20px;
        &.flxbox{
            display:flex;
            justify-content:space-between;
            .col{
                flex-basis:45%;
            }
        }
        .ant-form-item-label{
            display: block;
            width: 100%;
            text-align: left;
        }
        textarea{
            height:125px;
            border:1px solid #4eb0de;
            border-radius:4px;
            resize:none;
        }
    }

    .action-pan{
        text-align:center;
        margin-top:20px;
        margin-bottom: 20px;
        .sendBtn{
            font-family: "Open Sans";
            margin-top: 20px;
            font-weight: 700;
            background: #344177;
            color: #fff;
            font-size: 14px;
            border: 1.5px solid #344177;
            border-radius: 20px;
            margin: 0 5px;
            display: inline-block;
            text-transform: uppercase;
            cursor: pointer;
            width: 180px;
            height: 40px;

        }
    }

    

.ant-modal-content{
    border-radius:10px;
}

.react-tel-input .form-control{
    border: 1px solid #4eb0de;
    border-radius: 4px;
    font-size: 16px !important;
    color: #32407b !important;
    font-weight: normal;
}
.flag-dropdown{
    background:none;
    border:none;
}
.react-tel-input .country-list .country{padding:0 10px;}
.react-tel-input .selected-flag{background:none;}
    
}


`;



export default (InviteViaTextWrapper);